import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

const triggerCls =
  "font-body text-xs uppercase tracking-[0.2em] text-fog/70 underline-offset-4 transition-colors duration-300 hover:text-steel-light hover:underline";

function Section({ heading, children }) {
  return (
    <div className="space-y-2">
      <h4 className="font-display text-sm font-bold uppercase tracking-[0.15em] text-steel-light">
        {heading}
      </h4>
      <p className="font-body text-sm font-light leading-relaxed text-fog">{children}</p>
    </div>
  );
}

export default function LegalModals() {
  return (
    <div className="flex items-center gap-6">
      {/* Privacy Policy */}
      <Dialog>
        <DialogTrigger data-testid="privacy-policy-link" className={triggerCls}>
          Privacy Policy
        </DialogTrigger>
        <DialogContent
          data-testid="privacy-policy-modal"
          className="max-h-[82vh] overflow-y-auto border-hairline bg-surface text-cloud sm:max-w-2xl"
        >
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-bold tracking-tight text-cloud">
              Privacy Policy
            </DialogTitle>
          </DialogHeader>
          <div className="mt-2 space-y-5">
            <p className="font-body text-xs uppercase tracking-[0.2em] text-fog/60">
              Last updated: January 2026
            </p>
            <Section heading="Who we are">
              Al Yakhour LLC (&ldquo;Al Yakhour&rdquo;, &ldquo;we&rdquo;, &ldquo;us&rdquo;) operates this
              website and provides AI systems, software solutions, and digital marketing
              services. You can reach us at info@alyakhour.com.
            </Section>
            <Section heading="Information we collect">
              We collect the information you voluntarily provide through our contact form —
              your name, email address, reason for inquiry, and message. We also collect
              standard, non-identifying technical data (such as browser type and pages
              visited) to operate and improve the site.
            </Section>
            <Section heading="How we use your information">
              We use your information solely to respond to your enquiry, provide the
              services you request, and communicate with you about our offerings. We do not
              sell your personal information to third parties.
            </Section>
            <Section heading="Google user data & review management">
              Where our reputation-management services integrate with Google Business
              Profile, we access and process review and customer-feedback data only with
              the explicit authorization of the business owner, strictly to enable review
              response and management workflows. This data is used only for the intended
              service, is not sold, and is handled in line with the Google API Services User
              Data Policy, including its Limited Use requirements.
            </Section>
            <Section heading="Data retention & security">
              We retain contact submissions only as long as necessary to serve your request
              and apply reasonable technical and organizational measures to protect your
              data.
            </Section>
            <Section heading="Your rights">
              You may request access to, correction of, or deletion of your personal data at
              any time by emailing info@alyakhour.com.
            </Section>
            <Section heading="Contact">
              Questions about this policy? Email us at info@alyakhour.com.
            </Section>
          </div>
        </DialogContent>
      </Dialog>

      <span className="h-3 w-px bg-hairline" />

      {/* Terms of Service */}
      <Dialog>
        <DialogTrigger data-testid="terms-of-service-link" className={triggerCls}>
          Terms of Service
        </DialogTrigger>
        <DialogContent
          data-testid="terms-of-service-modal"
          className="max-h-[82vh] overflow-y-auto border-hairline bg-surface text-cloud sm:max-w-2xl"
        >
          <DialogHeader>
            <DialogTitle className="font-display text-2xl font-bold tracking-tight text-cloud">
              Terms of Service
            </DialogTitle>
          </DialogHeader>
          <div className="mt-2 space-y-5">
            <p className="font-body text-xs uppercase tracking-[0.2em] text-fog/60">
              Last updated: January 2026
            </p>
            <Section heading="Acceptance of terms">
              By accessing or using this website, you agree to these Terms of Service. If you
              do not agree, please do not use the site.
            </Section>
            <Section heading="Services">
              Al Yakhour LLC provides AI systems, software solutions, and digital marketing
              services. Content on this site is for general informational purposes and does
              not constitute a binding offer. Specific engagements are governed by separate
              written agreements.
            </Section>
            <Section heading="Acceptable use">
              You agree not to misuse the site, attempt to disrupt its operation, or use it
              for any unlawful purpose. Any information you submit must be accurate and your
              own to share.
            </Section>
            <Section heading="Intellectual property">
              All trademarks, logos, text, and design elements on this site are the property
              of Al Yakhour LLC and may not be reproduced without permission.
            </Section>
            <Section heading="Third-party services">
              Our services may integrate with third-party platforms (such as Google Business
              Profile). Your use of those platforms is subject to their respective terms.
            </Section>
            <Section heading="Limitation of liability">
              The site is provided &ldquo;as is&rdquo; without warranties of any kind. To the fullest
              extent permitted by law, Al Yakhour LLC is not liable for any indirect or
              consequential damages arising from your use of the site.
            </Section>
            <Section heading="Contact">
              For questions about these terms, email info@alyakhour.com.
            </Section>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
